import { FilesetResolver, GestureRecognizer, GestureRecognizerResult } from '@mediapipe/tasks-vision';

export type GestureType = 'None' | 'Open_Palm' | 'Closed_Fist' | 'Pointing_Up' | 'Thumb_Up' | 'Thumb_Down' | 'Victory';

export class GestureManager {
    private gestureRecognizer: GestureRecognizer | null = null;
    private isLoaded: boolean = false;

    constructor() {
        this.init();
    }

    private async init() {
        try {
            const vision = await FilesetResolver.forVisionTasks(
                "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.3/wasm"
            );
            this.gestureRecognizer = await GestureRecognizer.createFromOptions(vision, {
                baseOptions: {
                    modelAssetPath:
                        "https://storage.googleapis.com/mediapipe-models/gesture_recognizer/gesture_recognizer/float16/1/gesture_recognizer.task",
                    delegate: "GPU"
                },
                runningMode: "VIDEO",
                numHands: 2
            });
            this.isLoaded = true;
            console.log("GestureManager: Model loaded.");
        } catch (error) {
            console.error("GestureManager: Failed to load model", error);
        }
    }

    public detect(video: HTMLVideoElement, timestamp: number): GestureRecognizerResult | null {
        if (!this.isLoaded || !this.gestureRecognizer) return null;
        
        // Only recognize if video is playing and has data
        if (video.currentTime > 0 && video.readyState >= 2) {
             return this.gestureRecognizer.recognizeForVideo(video, timestamp);
        }
        return null;
    }
    
    public getHandData(result: GestureRecognizerResult | null, targetHand: 'Left' | 'Right'): { gesture: GestureType, x: number, y: number } | null {
        if (!result || !result.handedness || result.handedness.length === 0) return null;
        
        // Find index of the target hand
        const handIndex = result.handedness.findIndex(h => h[0].categoryName === targetHand);
        
        if (handIndex === -1) return null;
        
        // Get Gesture
        let gesture: GestureType = 'None';
        if (result.gestures.length > handIndex && result.gestures[handIndex].length > 0) {
            gesture = result.gestures[handIndex][0].categoryName as GestureType;
        }
        
        // Get Position
        let x = 0, y = 0;
        if (result.landmarks.length > handIndex && result.landmarks[handIndex].length > 0) {
             const wrist = result.landmarks[handIndex][0];
             x = wrist.x;
             y = wrist.y;
        }
        
        return { gesture, x, y };
    }

    public isReady(): boolean {
        return this.isLoaded;
    }
}
